export function deleteParticipantStateSelector(state) {
  return state.local.participants.deletion
}
